import { SearchOutlined } from '@ant-design/icons';
import { useForm } from 'antd/es/form/Form';
import { Button, Col, DatePicker, Divider, Form, Input, message, Row, Select } from 'antd';
import moment from 'moment';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  IListColumn,
  ISortColumn,
  PaginationResponse,
  TransactionHistoryParams,
} from 'src/@types/search-params';
import {
  getAllCancelPackage,
  getAllDataPackageNew,
} from 'src/api/register_and_cancel_and_load_package';
import TableContent from 'src/components/CTable';
import useWindowSize from 'src/hooks/useWindowSize';
import { useAppSelector } from 'src/redux/hook';
import { setGlobalState } from 'src/redux/slice/globalSlice';
import { orderStatus } from 'src/shared/common/package_assigned';
import { IOrderStatus, IPackageAssigned } from 'src/shared/interface/package_assigned';
import {
  exportExcel,
  formatDateTime,
  nonAccentVietnamese,
  parseQueryString,
  renderSubType,
} from 'src/utils';
import { renderOptionSubType } from 'src/utils/subType';
import CGridView from 'src/components/CGridView';
import { usePermission } from 'src/hooks/usePermission';
function CancelListPage() {
  const size = useWindowSize();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [form] = useForm();
  const [_, setSearchParams] = useSearchParams();
  const merchantInfo: string | null = localStorage.getItem('merchantInfo');
  const { openTabs, activeKeyId } = useAppSelector((state) => state.global);

  const [data, setData] = useState<PaginationResponse<IPackageAssigned[]>>();
  const [sortColumn, setSortColumn] = useState<ISortColumn>();
  const [dataPackage, setDataPackage] = useState<IOrderStatus[]>([]);

  const { hasPermission, PERMISSIONS } = usePermission();

  const fetchGetPackageAssigned = async () => {
    getAllDataPackageNew()
      .then((res: any) => {
        if (res) {
          const dataPackage: IOrderStatus[] = [{ value: '', label: 'Tất cả' }];
          res?.map((item: any) => {
            dataPackage?.push({
              label: item?.mbfName ?? '',
              value: item?.mbfCode ?? '',
            });
          });
          setDataPackage(dataPackage);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  function handleExport() {
    const link = document.createElement('a');
    link.target = '_blank';
    link.download = `danh_sach_huy_goi_${moment().format('DDMMYYYYHHmmss')}.xlsx`;
    exportExcel(
      process.env.REACT_APP_API_URL + '/api/DataPackage/cancel/export-excel' + location.search,
    )
      .then((res) => {
        link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.ms-excel' }));
        link.click();
      })
      .catch((error) => {
        if (error.status === 403) {
          message.error(`Tài khoản của bạn không có quyền truy cập vào chức năng này`);
        }
      });
  }

  function handleFormSearch(value: any) {
    let values = { ...value };
    values = {
      ...values,
      id: values.id?.trim(),
      dateFrom:
        value.dateRange && value?.dateRange[0]
          ? value?.dateRange[0].format('YYYY-MM-DD')
          : value.dateFrom ?? undefined,
      dateTo:
        value.dateRange && value?.dateRange[1]
          ? value?.dateRange[1].format('YYYY-MM-DD')
          : value.dateTo ?? undefined,
      dateRange: undefined,
      pageIndex: 1,
      pageSize: 10,
    };
    Object.keys(values).forEach((key) => {
      if (!values[key]) {
        delete values[key];
      }
    });
    setSortColumn(undefined);
    setSearchParams(values);
    fetchListPackageAssigned(values);
  }

  function openCreateCancelPackagePage() {
    dispatch(
      setGlobalState({
        activeKeyMenu: 'register-and-cancel-and-load-package/cancel/create',
      }),
    );
    if (!openTabs.find((tab) => tab.key === 'register-and-cancel-and-load-package/cancel/create')) {
      dispatch(
        setGlobalState({
          openTabs: [
            ...openTabs,
            {
              label: 'Tạo mới đơn hàng Huỷ gói',
              children: '',
              key: 'register-and-cancel-and-load-package/cancel/create',
              closable: true,
            },
          ],
        }),
      );
    }
    dispatch(setGlobalState({ order: undefined }));
    navigate(`/management/register-and-cancel-and-load-package/cancel/create`);
  }

  const handleDetailCancel = (order: any) => {
    dispatch(
      setGlobalState({
        activeKeyMenu: 'register-and-cancel-and-load-package/cancel/detail' + '?id=' + order.id,
      }),
    );
    if (
      !openTabs.find(
        (tab) =>
          tab.key === 'register-and-cancel-and-load-package/cancel/detail' + '?id=' + order.id,
      )
    ) {
      dispatch(
        setGlobalState({
          openTabs: [
            ...openTabs,
            {
              label: 'Xem chi tiết Huỷ gói ' + order.id,
              children: '',
              key: 'register-and-cancel-and-load-package/cancel/detail' + '?id=' + order.id,
              closable: true,
            },
          ],
        }),
      );
    }
    navigate(`/management/register-and-cancel-and-load-package/cancel/detail?id=${order.id}`);
  };

  const columns: IListColumn[] = [
    { name: 'STT', fieldName: 'index', width: 20, isHideSort: true },
    {
      name: 'Mã yêu cầu',
      fieldName: 'id',
      renderSpecialCard: (order: IPackageAssigned) => (
        <button
          className={`underline whitespace-nowrap cursor-pointer bg-transparent border-transparent ${
            hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.CANCEL_VIEW_DETAIL)
              ? 'text-blue-400'
              : 'text-gray-400'
          } font-semibold`}
          onClick={() => handleDetailCancel(order)}
          disabled={!hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.CANCEL_VIEW_DETAIL)}
        >
          {order.id ?? ''}
        </button>
      ),
    },
    {
      name: 'Mã gói',
      fieldName: 'mbfCode',
      isHideSort: false,
    },
    {
      name: 'Tên gói',
      fieldName: 'mbfName',
      isHideSort: false,
    },
    {
      name: 'Loại thuê bao',
      fieldName: 'subType',
      isHideSort: true,
      renderSpecialCard: (record) => {
        return <p>{renderSubType('', record?.subType)}</p>;
      },
    },
    {
      name: 'Trạng thái',
      fieldName: 'statusString',
      renderSpecialCard: (record: IPackageAssigned) => {
        const status = orderStatus.find((item) => item.value === record.statusString);
        return <span className='whitespace-nowrap'>{status?.label ?? ''}</span>;
      },
    },
    {
      name: 'Tổng cộng',
      fieldName: 'countSerial',
      isHideSort: true,
      width: '5%',
    },
    {
      name: 'Thành công',
      fieldName: 'quantitySuccess',
      isHideSort: true,
      width: '5%',
    },
    {
      name: 'Thất bại',
      fieldName: 'quantityFailed',
      isHideSort: true,
      width: '5%',
    },
    {
      name: 'Người tạo',
      fieldName: 'createdBy',
    },
    {
      name: 'Ngày tạo',
      fieldName: 'createdAt',
      renderSpecialCard: (record: IPackageAssigned) => {
        return <span>{record.createdAt ? formatDateTime(record.createdAt) : ''}</span>;
      },
    },
    {
      name: 'Ngày cập nhật cuối',
      fieldName: 'updatedAt',
      renderSpecialCard: (record: IPackageAssigned) => {
        return (
          <span>
            {record.updatedAt &&
            record.createdAt &&
            new Date(record.updatedAt).getTime() === new Date(record.createdAt).getTime()
              ? ''
              : record.updatedAt
              ? formatDateTime(record.updatedAt)
              : ''}
          </span>
        );
      },
    },
    {
      name: 'Người cập nhật cuối',
      fieldName: 'updatedBy',
    },
    {
      name: 'Thao tác',
      fieldName: 'id',
      renderSpecialCard: (order) => (
        <button
          className={`underline whitespace-nowrap cursor-pointer bg-transparent border-transparent ${
            hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.CANCEL_VIEW_DETAIL)
              ? 'text-blue-400'
              : 'text-gray-400'
          } font-semibold`}
          disabled={!hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.CANCEL_VIEW_DETAIL)}
          onClick={() => handleDetailCancel(order)}
        >
          Xem chi tiết
        </button>
      ),
      isHideSort: true,
    },
  ];

  const fetchListPackageAssigned = async (dataParams?: TransactionHistoryParams) => {
    const params = dataParams ? dataParams : parseQueryString(location.search);

    const res = await getAllCancelPackage(params);
    if (res) {
      setData(res);
    }
  };

  useEffect(() => {
    fetchGetPackageAssigned();
    fetchListPackageAssigned();
    setSortColumn(undefined);
    form.resetFields();
  }, [activeKeyId]);

  return (
    <Fragment>
      <Form
        onFinish={handleFormSearch}
        layout={size.width < 768 ? 'vertical' : 'inline'}
        className='gap-2'
      >
        <Form.Item name='id'>
          <Input prefix={<SearchOutlined />} placeholder='Mã đơn' allowClear />
        </Form.Item>
        <Form.Item name='mbfCode' label='Gói'>
          <Select
            showSearch
            className='min-w-[150px]'
            placeholder='Vui lòng chọn'
            defaultValue={''}
            options={dataPackage}
            filterOption={(input, option) => {
              return nonAccentVietnamese(
                (option!.label as unknown as string).toString()?.toLowerCase(),
              ).includes(nonAccentVietnamese(input?.toLowerCase()?.trim()));
            }}
          ></Select>
        </Form.Item>
        <Form.Item name='subType' label='Loại thuê bao'>
          <Select
            showSearch
            className='min-w-[200px]'
            placeholder='Vui lòng chọn'
            defaultValue={''}
            options={renderOptionSubType(true)}
            filterOption={(input, option) => {
              return nonAccentVietnamese(
                (option!.label as unknown as string).toString()?.toLowerCase(),
              ).includes(nonAccentVietnamese(input?.toLowerCase()?.trim()));
            }}
          ></Select>
        </Form.Item>
        <Form.Item name='status' label='Trạng thái'>
          <Select
            showSearch
            className='min-w-[150px]'
            placeholder='Vui lòng chọn'
            defaultValue={''}
            options={orderStatus}
          ></Select>
        </Form.Item>
        <Form.Item name='' label='Người tạo'>
          <Select
            showSearch
            className='min-w-[150px]'
            defaultValue={merchantInfo ? JSON.parse(merchantInfo).merchantName : ''}
          >
            {/* <Select.Option value='merchantName'>Tất cả</Select.Option> */}
            <Select.Option value='merchantName'>
              {merchantInfo ? JSON.parse(merchantInfo).merchantName : ''}
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item name='dateRange' label='Ngày tạo'>
          <DatePicker.RangePicker
            disabledDate={(current) => current && current >= moment().endOf('day')}
            placeholder={['từ', 'đến']}
            format={'DD/MM/YYYY'}
          />
        </Form.Item>

        <div className='row-button' style={{ justifyContent: 'flex-end', margin: '1.5rem 0' }}>
          <Button type='primary' htmlType='submit'>
            Tìm kiếm
          </Button>
          {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.CANCEL_CREATE) && (
            <Button onClick={openCreateCancelPackagePage}>Tạo mới</Button>
          )}
          {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.CANCEL_EXPORT) && (
            <Button onClick={handleExport}>Export</Button>
          )}
        </div>
      </Form>

      <div className='mt-4 overflow-hidden'>
        {size.width < 1024 ? (
          <CGridView
            length={data?.results.length}
            totalRecord={data?.rowCount ?? 0}
            columns={columns}
            title={() => <div className='text-xl font-bold my-3'>Danh sách đơn hàng hủy gói</div>}
          >
            {data?.results && data?.results.length > 0 ? (
              data?.results.map((item: IPackageAssigned) => {
                return (
                  <div key={'data-row-' + item.id}>
                    <Divider className='border-t-black' />

                    <Row className='mb-6 items-center' gutter={[4, 16]}>
                      {columns.map((ele) => {
                        if (ele.fieldName !== 'index' && ele.fieldName !== 'action') {
                          return (
                            <>
                              <Col span={11} className={`font-bold label`}>
                                <div className='flex gap-2 items-center'>{ele.name}</div>
                              </Col>
                              <Col className='break-words text-right' span={13}>
                                {ele?.renderSpecialCard
                                  ? ele?.renderSpecialCard(item, null, null, null)
                                  : item[`${ele?.fieldName}`]}
                              </Col>
                            </>
                          );
                        } else if (ele.fieldName === 'action') {
                          return (
                            <Col key={'column-' + item.id + ele.fieldName} span={24}>
                              <div className='flex gap-6'>
                                {ele?.renderSpecialCard
                                  ? ele?.renderSpecialCard(item, null, null, null)
                                  : item[`${ele?.fieldName}`]}
                              </div>
                            </Col>
                          );
                        } else {
                          return <></>;
                        }
                      })}
                    </Row>
                  </div>
                );
              })
            ) : (
              <p>{'Không có dữ liệu'}</p>
            )}
          </CGridView>
        ) : (
          <TableContent
            bordered
            scroll={{ x: 'max-content' }}
            locale={{ emptyText: 'Không tìm thấy kết quả' }}
            dataSource={data?.results ?? []}
            columns={columns}
            totalRecord={data?.rowCount ?? 0}
            sortColumn={sortColumn}
            size='middle'
            onPageChange={(pageNumber, pageSize) => {
              const pagination = parseQueryString(location.search);
              fetchListPackageAssigned({
                ...pagination,
                pageIndex: pageNumber ?? 1,
                pageSize: pageSize ?? 10,
                sortField: pagination.sortField ?? undefined,
                asc: pagination.asc ?? undefined,
              });
            }}
            onSort={(sort: ISortColumn) => {
              const pagination = parseQueryString(location.search);
              fetchListPackageAssigned({
                ...pagination,
                pageIndex: pagination.pageIndex ?? 1,
                pageSize: pagination.pageSize ?? 10,
                sortField: sort.fieldName,
                asc:
                  sort.orderType === 'asc' ? true : sort.orderType === 'desc' ? 'false' : undefined,
              });
            }}
          />
        )}
      </div>
    </Fragment>
  );
}

export default CancelListPage;
